import React, {useRef, useEffect} from 'react'

import ApexCharts from 'apexcharts'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faTable, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useParams } from "react-router-dom";
import { PageTitle } from "../../../../../_template/layout/core/PageData";
import SAISVG from '../../../../../_template/helpers/CommonFunction';

const BotAnalytics = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');

    const pageTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: 'Analytics',
            path: loginUserType === 'SA' ? `${company}/analytics/bot-analytics` : '/analytics/bot-analytics',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const productType = [
        { value: 'option 1', label: 'Option 1' },
        { value: 'option 2', label: 'Option 2' },
        { value: 'option 3', label: 'Option 3' },
        { value: 'option 4', label: 'Option 4' },
        { value: 'option 5', label: 'Option 5' },
    ]

    const topCardArray = [
        {
            title:'Total Convertion',
            value: 120,
            bg_color : 'bg-dark'
        },
        {
            title:'Hand of rate',
            value: 32,
            bg_color : 'bg-primary'
        },
        {
            title:'User retantion',
            value: 14,
            bg_color : 'bg-danger'
        },
        {
            title:'Total message send',
            value: 3,
            bg_color : 'bg-warning'
        },
       
    ]

    const chartRef = useRef(null);
    const refreshChart = () => {
        if (!chartRef.current) {
          return
        }
    
        const height = parseInt(350);
    
        const chart = new ApexCharts(chartRef.current, getChartOptions(height))
        if (chart) {
          chart.render()
        }
    
        return chart
    }
    useEffect(() => {
        setTimeout(() => {
            const chart = refreshChart();
            if (chart) {
                chart.updateOptions({
                    chart: { height: 350 },
                });
            }
            return () => {
                if (chart) {
                    chart.destroy();
                }
            };
        }, 200);
           
    }, [chartRef]);

    // ----------- project chart ----------- //

    const projectChartRef = useRef(null);

    const refreshMode = () => {
        if (!projectChartRef.current) {
          return;
        }
        const height = parseInt(350);
        const chart = new ApexCharts(projectChartRef.current, productChart(height));
        if (chart) {
          chart.render();
        }
        return chart;
    };

    useEffect(() => {
        setTimeout(() => {
            const p_chart = refreshMode();
            if (p_chart) {
                p_chart.updateOptions({
                    p_chart: { height: 350 },
                });
            }
            return () => {
                if (p_chart) {
                    p_chart.destroy();
                }
            };
        }, 200);
            
    }, [projectChartRef]);


    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>BOT Analytics</PageTitle>
            <>
                <div className='row'>
                    {topCardArray.map(data =>
                        <div className="col-md-3">
                            <div className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 ${data.bg_color}`}>
                                <div className="card-header pt-5 mb-3">
                                    <div className={`d-flex flex-center rounded-circle h-80px w-80px ${data.bg_color}`} style={{border: '1px dashed rgba(255, 255, 255, 0.4)'}}>
                                        <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-white svg-icon-5hx" />
                                    </div>
                                </div>
                                <div className="card-body d-flex align-items-end mb-3 py-3">
                                    <div className="d-flex align-items-center">
                                        <span className="fs-4x text-white fw-bold me-6 inactive-vehicle-count">
                                            {data.value}
                                        </span>
                                    </div>
                                </div>
                                <div className="card-footer py-3" style={{borderTop : '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                                    <div className="fw-bold text-white py-2">
                                        <span className="fs-3 d-block">{data.title}</span>
                                        <span className="opacity-50">{data.title}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
            <>
                <div className="row mt-5">
                    <div className='col-md-12'>
                        <div className={`card card-xl-stretch border`}>
                            <div className='card-header border-0 pt-5'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bold fs-3 mb-1'>
                                        Session Analytics
                                    </span>
                                    <span className='text-muted fw-semibold fs-7'>More than 1000 new records</span>
                                </h3>
                                <div className="card-toolbar">
                                    <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bold" id="kt_security_summary_tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary active"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_hours"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Collective Insight
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_day"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Collective Insight
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className="row ">
                                    <div className='col-md-4'>
                                        <Select 
                                            className='react-select-styled react-select-solid' 
                                            classNamePrefix='react-select' 
                                            options={productType} 
                                            placeholder='Select an option' 
                                        />
                                    </div>
                                    <div className='col-md-4'>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder="name@example.com"
                                        />
                                    </div>
                                    <div className='col-md-4 text-end'>
                                        <button type="button" className="btn btn-dark me-2">
                                            <FontAwesomeIcon className='me-2' icon={faMagnifyingGlass} />
                                            Search
                                        </button>

                                    
                                        <button 
                                            type="button" 
                                            className="btn btn-dark me-2"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            
                                            Export
                                            <FontAwesomeIcon className='ms-2' icon={faAngleDown} />
                                        </button>

                                        <div className='menu menu-sub menu-sub-dropdown w-200px w-md-200px' data-sai-menu='true'>
                                            <div className="row p-2">
                                                <div className="col-md-12 text-start">
                                                    <div className="menu-item px-3">
                                                        <button className="btn btn-active-light-primary menu-link">
                                                            CSV
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faTable} className='fs-4' />
                                        </button>
                                    </div>
                                </div>
                                <div ref={chartRef} style={{height: '100%'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
            <>
                <div className="row mt-5">
                    <div className='col-md-12'>
                        <div className={`card card-xl-stretch mb-xl-8 border`}>
                            <div className='card-header border-0 pt-5'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bold fs-3 mb-1'>
                                        Project Analytics
                                    </span>
                                    <span className='text-muted fw-semibold fs-7'>More than 1000 new records</span>
                                </h3>
                                <div className="card-toolbar">
                                    <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bold" id="kt_security_summary_tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_hours"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Collective Insight
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_day"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Individual Insight
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className="row ">
                                    <div className='col-md-4'>
                                        <Select 
                                            className='react-select-styled react-select-solid' 
                                            classNamePrefix='react-select' 
                                            options={productType} 
                                            placeholder='Select an option' 
                                        />
                                    </div>
                                    <div className='col-md-4'>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder="name@example.com"
                                        />
                                    </div>
                                    <div className='col-md-4 text-end'>
                                        <button type="button" className="btn btn-dark me-2">
                                            <FontAwesomeIcon className='me-2' icon={faMagnifyingGlass} />
                                            Search
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-dark me-2"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Export
                                            <FontAwesomeIcon className='ms-2' icon={faAngleDown} />
                                        </button>
                                        <div className='menu menu-sub menu-sub-dropdown w-200px w-md-200px' data-sai-menu='true'>
                                            <div className="row p-2">
                                                <div className="col-md-12 text-start">
                                                    <div className="menu-item px-3">
                                                        <button className="btn btn-active-light-primary menu-link">
                                                            CSV
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faTable} className='fs-4' />
                                        </button>
                                    </div>
                                </div>
                                <div ref={projectChartRef} style={{height: '100%'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
        
    )
}

export {BotAnalytics}

function getChartOptions() {
    const labelColor = '#A1A5B7';
    const borderColor = '#eff2f5';
    const baseColor = '#009ef7';
  
    return {
      series: [
        {
          name: 'Total convertion',
          data: [44, 55, 57, 56, 61, 58, 10, 23, 56, 80, 88, 55, 36, 90, 56],
        },
        {
          name: 'Transfer call',
          data: [36, 20, 50, 40, 32, 7, 3, 18, 23, 14, 56, 45, 25, 36, 45],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
        xaxis: {
            categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'],
            axisBorder: {
            show: false,
            },
            axisTicks: {
            show: false,
            },
            labels: {
            style: {
                colors: labelColor,
                fontSize: '12px',
            },
            },
        },
        yaxis: {
            labels: {
            style: {
                colors: labelColor,
                fontSize: '12px',
            },
            },
        },
        fill: {
            opacity: 1,
        },
        states: {
            normal: {
            filter: {
                type: 'none',
                value: 0,
            },
            },
            hover: {
            filter: {
                type: 'none',
                value: 0,
            },
            },
            active: {
            allowMultipleDataPointsSelection: false,
            filter: {
                type: 'none',
                value: 0,
            },
            },
        },
        tooltip: {
            style: {
            fontSize: '12px',
            },
            y: {
            formatter: function (val) {
                return val
            },
            },
        },
        colors: [ '#181c32' , baseColor ],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
            lines: {
                show: true,
            },
            },
        },
    }
}

function productChart() {
    const labelColor = '#A1A5B7'
    const borderColor = '#eff2f5'
    const baseColor = '#7239ea'

    return {
        series: [
            {
                name: 'Search interest',
                data: [
                    5, 7, 3, 2, 10, 26, 8, 4, 12, 13, 11, 15, 5, 45, 50, 35, 6, 45, 19, 25, 7, 15, 35, 5, 55, 21, 63, 7, 56,65
                ],
            },
            {
                name: 'Interest frequency',
                data: [
                    3, 6, 1, 3, 8, 12, 10, 15, 56, 15, 19, 18, 50, 41, 21, 63, 56, 8, 65, 47, 15, 36, 15, 12, 65, 15, 10, 60, 10,25
                ],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'area',
            height: 350,
            redrawOnParentResize: true,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {},
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 1,
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
            colors: [baseColor],
        },
      
        xaxis: {
            categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21','22', '23', '24','25','26','27','28','29','30'],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
            crosshairs: {
                position: 'front',
                stroke: {
                    color: baseColor,
                    width: 1,
                    dashArray: 3,
                },
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return val
                },
            },
        },
        // colors: [lightColor],
        colors: ['rgba(241, 241, 242, 0.7)', 'rgba(236, 248, 255, 0.7)', 'rgba(188, 253, 253, 0.7)', 'rgba(255, 245, 248, 0.7)', 'rgba(255, 248, 221, 0.7)'],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        markers: {
            strokeColors: baseColor,
            strokeWidth: 3,
        },
    }
}